import { fromJS } from 'immutable'
import {
  REPORT_HEADCOUNT_EXPORT_REQUEST,
  REPORT_HEADCOUNT_EXPORT_SUCCESS,
  REPORT_HEADCOUNT_EXPORT_FAILURE,
  REPORT_HEADCOUNT_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case REPORT_HEADCOUNT_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case REPORT_HEADCOUNT_EXPORT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('url', fromJS(action.payload.url))
    case REPORT_HEADCOUNT_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case REPORT_HEADCOUNT_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report/report-headcount-export-reducer.js